 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-aws-js","11":"component---src-pages-bot-platform-apple-messages-for-business-js","12":"component---src-pages-bot-platform-facebook-js","13":"component---src-pages-bot-platform-google-business-messages-js","14":"component---src-pages-bot-platform-index-js","15":"component---src-pages-bot-platform-telegram-js","16":"component---src-pages-bot-platform-viber-js","17":"component---src-pages-caab-js","18":"component---src-pages-case-studies-js","19":"component---src-pages-certification-confirm-js","20":"component---src-pages-certification-index-js","21":"component---src-pages-certification-junior-js","22":"component---src-pages-cloud-js","23":"component---src-pages-code-js","24":"component---src-pages-communication-js","25":"component---src-pages-download-js","26":"component---src-pages-events-js","27":"component---src-pages-faq-js","28":"component---src-pages-form-caab-js","29":"component---src-pages-form-certification-corp-js","30":"component---src-pages-form-certification-employees-js","31":"component---src-pages-form-certification-partner-js","32":"component---src-pages-form-extended-trial-js","33":"component---src-pages-form-index-js","34":"component---src-pages-form-live-demo-js","35":"component---src-pages-form-sales-js","36":"component---src-pages-form-submit-vacancy-js","37":"component---src-pages-form-support-js","38":"component---src-pages-form-unsubscribe-js","39":"component---src-pages-form-webinar-js","40":"component---src-pages-form-workshop-js","41":"component---src-pages-index-js","42":"component---src-pages-iot-js","43":"component---src-pages-jobs-js","44":"component---src-pages-knowledge-js","45":"component---src-pages-learn-js","46":"component---src-pages-manage-api-js","47":"component---src-pages-media-js","48":"component---src-pages-new-pricing-private-cloud-js","49":"component---src-pages-new-pricing-public-cloud-js","50":"component---src-pages-new-pricing-success-js","51":"component---src-pages-new-pricing-support-js","52":"component---src-pages-partnership-js","53":"component---src-pages-people-js","54":"component---src-pages-pricing-js","55":"component---src-pages-pricing-pay-js","56":"component---src-pages-pricing-private-cloud-js","57":"component---src-pages-pricing-public-cloud-js","58":"component---src-pages-pricing-support-js","59":"component---src-pages-processes-js","60":"component---src-pages-product-js","61":"component---src-pages-software-js","62":"component---src-pages-terms-and-conditions-js","63":"component---src-pages-tutorials-js","64":"component---src-pages-workshops-js","65":"component---src-templates-blog-blog-js","66":"component---src-templates-post-post-js"}[chunkId]||chunkId) + "-" + {"0":"a8e30440d6033553e40a","1":"3205806509c41693ba58","2":"2425b4bdd0bc125a77e7","3":"1df0855338ce96ec0569","4":"4760579dad092e278fc7","5":"2a226c6dc89cd6066abe","6":"fc50bf52c12962c43af7","8":"ac8bda6012316c5e7d81","9":"5a3d7b4d1b5482972f8f","10":"d752b15edd02d9eb6310","11":"cf5959ef57d8c06ed007","12":"71c837e0528ab0885c67","13":"e165cd43fce7ecee27de","14":"de673c1250ad3b63c7f4","15":"8b7d1e0c499dec5286a6","16":"914233357f922b389269","17":"2927e737b6fafb541c14","18":"490ec6671a76e7e5eac2","19":"84149b116b95d96adb28","20":"f9b7a3803861581b824c","21":"5055f465f88607f14682","22":"3bfb99b94245c165fdaa","23":"22734515d7928a92c755","24":"73f16326f694d8df35e1","25":"761b2d700c7fcc202514","26":"6f73920b7930608ec2ce","27":"377929087809bf488173","28":"f775f5d299eeb2791e4d","29":"8cadce9778eb418c5d92","30":"5f4b42df55b5b3b7b697","31":"d51ca31368484180108b","32":"94ac2ba58a7aa1ead70a","33":"7b2abcad9d45526fed82","34":"c3066687fbc4d226e417","35":"31395c9b038e43a5c62f","36":"04565cdd52c03f903e94","37":"d286a55bc26ddeb89a21","38":"00fb9a062f5dabd50f67","39":"6ac39e2020c79128f389","40":"631921a7a06c8ce40f18","41":"1597f61ffe2afb0aa011","42":"6db6eb4ea91955d79acf","43":"67794655c4a1681ed219","44":"b2922b91cd2332ba6e60","45":"727ceb4c02021b6dc958","46":"760240df3bceb1cbc72f","47":"bdecf4c9b98327a1fc48","48":"64b9651ef1ac434095dc","49":"b9387c11d2fbb6ff95c0","50":"ca495cb2b41fe1de79c7","51":"d20cb7fb932cd00f81c1","52":"dee932c788061476e562","53":"58b27b63dbb70b9e089e","54":"2e848fde28247173cbb6","55":"a01e729cd9b385b11c67","56":"075a33d319ef1016ba5a","57":"e8009eed8fa1fac6df29","58":"5019ee9421c287703cf8","59":"4823132187a03331fa5f","60":"2502dd65cc81c065c980","61":"936403cc34a851db5199","62":"526af39d6b4d84a72dd8","63":"7df0e557099e66f7e883","64":"594f81120c0d624d86ad","65":"c67a51e7b99a859ff177","66":"87f994bcdcd2845318ed","68":"670cfdc084427da9a1e1","69":"3cfd3a67d4609acc7c02"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-aws-js","11":"component---src-pages-bot-platform-apple-messages-for-business-js","12":"component---src-pages-bot-platform-facebook-js","13":"component---src-pages-bot-platform-google-business-messages-js","14":"component---src-pages-bot-platform-index-js","15":"component---src-pages-bot-platform-telegram-js","16":"component---src-pages-bot-platform-viber-js","17":"component---src-pages-caab-js","18":"component---src-pages-case-studies-js","19":"component---src-pages-certification-confirm-js","20":"component---src-pages-certification-index-js","21":"component---src-pages-certification-junior-js","22":"component---src-pages-cloud-js","23":"component---src-pages-code-js","24":"component---src-pages-communication-js","25":"component---src-pages-download-js","26":"component---src-pages-events-js","27":"component---src-pages-faq-js","28":"component---src-pages-form-caab-js","29":"component---src-pages-form-certification-corp-js","30":"component---src-pages-form-certification-employees-js","31":"component---src-pages-form-certification-partner-js","32":"component---src-pages-form-extended-trial-js","33":"component---src-pages-form-index-js","34":"component---src-pages-form-live-demo-js","35":"component---src-pages-form-sales-js","36":"component---src-pages-form-submit-vacancy-js","37":"component---src-pages-form-support-js","38":"component---src-pages-form-unsubscribe-js","39":"component---src-pages-form-webinar-js","40":"component---src-pages-form-workshop-js","41":"component---src-pages-index-js","42":"component---src-pages-iot-js","43":"component---src-pages-jobs-js","44":"component---src-pages-knowledge-js","45":"component---src-pages-learn-js","46":"component---src-pages-manage-api-js","47":"component---src-pages-media-js","48":"component---src-pages-new-pricing-private-cloud-js","49":"component---src-pages-new-pricing-public-cloud-js","50":"component---src-pages-new-pricing-success-js","51":"component---src-pages-new-pricing-support-js","52":"component---src-pages-partnership-js","53":"component---src-pages-people-js","54":"component---src-pages-pricing-js","55":"component---src-pages-pricing-pay-js","56":"component---src-pages-pricing-private-cloud-js","57":"component---src-pages-pricing-public-cloud-js","58":"component---src-pages-pricing-support-js","59":"component---src-pages-processes-js","60":"component---src-pages-product-js","61":"component---src-pages-software-js","62":"component---src-pages-terms-and-conditions-js","63":"component---src-pages-tutorials-js","64":"component---src-pages-workshops-js","65":"component---src-templates-blog-blog-js","66":"component---src-templates-post-post-js"}[chunkId]||chunkId) + "." + {"0":"7a918dc47994f8adaf37","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
